import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import React, { useState } from "react";
import styles from "./DatagridExportButton.module.sass";
import Connect from "colbi_web_ui/lib/components/Connect";
import {
    SovosBox,
    SovosIconButton,
    SovosMenu,
    SovosMenuItem,
    SovosTypography,
    SovosLinearProgress,
} from "mosaic-react";
import { Download } from "mosaic-react-icons";

const DatagridExportButton = (props) => {
    const {
        data,
        exportableArray = [],
        alternativeQueryData,
        modalToUse = "DatagridMultipleDownloadDialog",
        showCsvOption = false,
    } = props;
    const { download, downloadableQueries, locale, i18n, totalLinesCsv, pushDialog, downloadFile, downloadCsvStreamAction } =
        useGlobalValue();
    
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleExport = (format) => {
        handleClose();
        const queriesToDownload = alternativeQueryData || downloadableQueries;
        if (format === "csv") {
            downloadCsvStreamAction && downloadCsvStreamAction(queriesToDownload, locale);
        } else {
            download && download(queriesToDownload, locale, null);
        }
    };

    const handleDirectDownload = (downloading) => {
        if (!downloading) {
            const queriesToDownload = alternativeQueryData || downloadableQueries;
            download && download(queriesToDownload, locale, null);
        }
    };

    return (
        <Connect to={["search", "downloading"]}>
            {({ downloading }) => (
                <SovosBox>
                    {downloading && (
                        <SovosBox
                            sx={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.3)",
                                zIndex: 1300,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <SovosBox
                                sx={{
                                    backgroundColor: "white",
                                    padding: "24px 48px",
                                    borderRadius: "8px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                                }}
                            >
                                <SovosLinearProgress sx={{ width: "200px", mb: 2 }} />
                                <SovosTypography variant="body1">{i18n`Downloading...`}</SovosTypography>
                            </SovosBox>
                        </SovosBox>
                    )}
                    <SovosBox>
                        {data && data.length ? (
                            <SovosBox className={`${styles["export-button"] || ""}`}>
                                {!exportableArray.length &&
                                (alternativeQueryData ||
                                    (downloadableQueries && downloadableQueries.length === 1)) ? (
                                    showCsvOption ? (
                                        <>
                                            <SovosIconButton
                                                tooltipText={"Download"}
                                                children={<Download style={{ fill: "#545E75" }} />}
                                                className={`${styles["action-button"]} ${
                                                    downloading ? styles["has-activity"] : ""
                                                }`}
                                                onClick={handleClick}
                                                aria-controls={open ? "export-format-menu" : undefined}
                                                aria-haspopup="true"
                                                aria-expanded={open ? "true" : undefined}
                                            />
                                            <SovosMenu
                                                id="export-format-menu"
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={handleClose}
                                                MenuListProps={{
                                                    "aria-labelledby": "export-button",
                                                }}
                                            >
                                                <SovosMenuItem onClick={() => handleExport("xlsx")}>
                                                    <SovosBox>
                                                        <SovosTypography variant="body1" fontWeight="medium">
                                                            {i18n`XLSX (Excel)`}
                                                        </SovosTypography>
                                                        <SovosTypography variant="caption" color="text.secondary">
                                                            {i18n`Limit 120000 rows`}
                                                        </SovosTypography>
                                                    </SovosBox>
                                                </SovosMenuItem>
                                                <SovosMenuItem onClick={() => handleExport("csv")}>
                                                    <SovosBox>
                                                        <SovosTypography variant="body1" fontWeight="medium">
                                                            {i18n`CSV`}
                                                        </SovosTypography>
                                                    </SovosBox>
                                                </SovosMenuItem>
                                            </SovosMenu>
                                        </>
                                    ) : (
                                        <SovosIconButton
                                            tooltipText={"Download XLSX"}
                                            children={<Download style={{ fill: "#545E75" }} />}
                                            className={`${styles["action-button"]} ${
                                                downloading ? styles["has-activity"] : ""
                                            }`}
                                            onClick={() => handleDirectDownload(downloading)}
                                        />
                                    )
                                ) : (
                                    <SovosIconButton
                                        tooltipText={"Download"}
                                        children={<Download style={{ fill: "#545E75" }} />}
                                        onClick={() => {
                                            !downloading &&
                                                pushDialog(
                                                    modalToUse,
                                                    i18n`Chose donwload options`,
                                                    {
                                                        queries:
                                                            exportableArray &&
                                                            exportableArray.length
                                                                ? exportableArray.map((elem) => ({
                                                                      ...(alternativeQueryData
                                                                          ? alternativeQueryData
                                                                          : downloadableQueries.length
                                                                            ? downloadableQueries[0]
                                                                            : {}),
                                                                      exportableEntity: elem,
                                                                  }))
                                                                : downloadableQueries,
                                                        download,
                                                        locale,
                                                        totalLinesCsv,
                                                        downloadFile,
                                                        pushDialog,
                                                        downloadCsvStreamAction,
                                                        showCsvOption,
                                                    },
                                                )
                                                    .then(() => {})
                                                    .catch(() => null);
                                        }}
                                    />
                                )}
                            </SovosBox>
                        ) : null}
                    </SovosBox>
                </SovosBox>
            )}
        </Connect>
    );
};

export default DatagridExportButton;
